import React from 'react';
import { useTranslation } from 'react-i18next';

import { HelperTooltip, OfficialAccountAvatar } from '@/components';

import styles from './index.module.scss';

// UNPROCESSED = 0
// NOT RELATED= 1
// RECEIVED = 2
// PLANNED = 3
// IN PROCESS = 4
// FINISHED = 5

export const ProposalStatusTags = ({
  statusList,
}: {
  statusList?: Array<OfficialAccount & { process_status: number }>;
}) => {
  const { t, i18n } = useTranslation();

  return (
    <div className={styles.tagsContainer}>
      {statusList?.map(({ process_status, ...official }) => {
        const isExist = i18n.exists('ProposalStatusTags.label', {
          context: `${process_status}`,
        });
        if (!isExist) {
          return null;
        }
        const statusLabel = t('ProposalStatusTags.label', {
          context: `${process_status}`,
        });
        return (
          <HelperTooltip
            key={official?.name}
            title={t('ProposalStatusTags.title', {
              name: official.name,
              status: statusLabel,
            })}>
            <span className={styles.tag}>
              <OfficialAccountAvatar
                logoTooltipVisible={false}
                data={official}
                size={16}
                logoOption={{ size: 8 }}
              />
              <span className={styles.status}>{statusLabel}</span>
            </span>
          </HelperTooltip>
        );
      })}
    </div>
  );
};
